import React from "react";
import { CtaButton } from "./CtaButton";
type Props = {
  label: string;
  note?: string;
  tone?: "dark" | "light";
};
export function SectionCta({
  label,
  note,
  tone = "light"
}: Props) {
  return <div className="mx-auto mt-10 max-w-xl" data-id="element-65" data-mp="3idyivq5djjng">
      <CtaButton label={label} data-id="element-66" data-mp="3id6y7adbf6by" />
      {note && <p className={`mt-3 text-center text-sm font-medium ${tone === "dark" ? "text-white/75" : "text-muted"}`} data-id="element-67" data-mp="3nc0aizgv8raj">{note}</p>}
    </div>;
}